<template>
  <div
    class="vm-nav-stack-mobile flex-box flex-align-items-center flex-justify-content-space-between"
  >
    <div class="flex-box flex-a-center">
         <div class="gl-hover-text left-area" @click="back">
            <slot name="left-area">
                <i class="afd afd-arrow-left fs24 mr8"></i>
            </slot>
        </div>
        <template v-if="!GL.ENV.is_afd_client" >
            <btn v-if="!GL.ENV.is_wechat || (GL.ENV.is_wechat && GL.ENV.is_ios)" class="look3 pl8 pr8 fs12" @click.native="$mixin_open_app">{{$t('c.NavStackMobile.text1')}}</btn>
            <wechat-open-app v-if="GL.ENV.is_wechat && GL.ENV.is_android"/>
        </template>
    </div>
    <div class="title-area">
      <slot name="title">
        <router-link class="flex-box flex-align-items-center" to="/">
          <img class="w_30 mr8" src="/static/img/logo/logo.png" alt="logo" />
          <span class="purple">{{$t('c.NavStackMobile.text2')}}</span>
        </router-link>
      </slot>
    </div>
    <div class="right-area">
      <slot name="right-area">
        <div class="flex-box flex-align-items-center">
          <div
            v-if="is_show_btn"
            class="flex-box flex-align-items-center purple"
            @click="show_modal_feed"
          >
            <i class="afd afd-plus fs12"></i>
            <span class="ml4 fs14">{{$t('c.NavStackMobile.text3')}}</span>
          </div>
          <!-- <btn v-else class="look3 pl8 pr8 fs12" @click.native="$mixin_router_push('/app')">App下载</btn> -->
          <!-- <wechat-open-app v-else-if="GL.ENV.is_wechat"/> -->
          <div
            v-if="!session_user && $route.name != 'login'"
            :to="{ name: 'login' }"
            class="login-door fs14"
            @click="jump('login')"
            >{{$t('c.NavStackMobile.text4')}}</div>
          <div
            v-if="!session_user && $route.name != 'reg'"
            :to="{name: 'reg'}"
            class="fs14 reg-door fwb purple ml16"
            @click="jump('reg')"
          >{{$t('c.NavStackMobile.text5')}}</div>
          <!-- <i v-if="$route.name == 'aSlug'" class="afd afd-search fs20 ml16" @click="open_slug_search"></i> -->
          <nav-menu-mobile v-if="session_user" class="ml18" :is_icon_avatar="mixin_is_nav_icon_avatar"></nav-menu-mobile>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "nav-stack-mobile",
  props: {},
  computed: {
    ...mapState("app", [
      "session_user",
      "auth_token",
      "this_user",
      "user_status",
      "is_show_publish_feed"
    ]),
    ...mapState("user", ["this_user"]),
    is_creator() {
      if (
        this.session_user &&
        this.session_user.creator &&
        this.session_user.creator.status
      ) {
        return true;
      }
      return false;
    },
    is_show_btn(){
        return this.is_creator && this.this_user && this.session_user && this.this_user.url_slug == this.session_user.url_slug && this.$route.name != 'slug' && this.$route.name != 'groupGroupId'
    }
  },
  data() {
    return {
        new_page_tab:this.$route.query.new_page_tab,
    };
  },
  watch: {
    this_user(v) {}
  },
  mounted() {
  },
  methods: {
    show_modal_feed() {
      this.$modal.show(
        () => import("@/components/ModalFeed"),
        {},
        {
          pivotY: 0.5,
          clickToClose: false,
          classes: "v--modal-feed v--modal",
          height: "100%",
          width: "100%",
          adaptive: true
        }
      );
    },
    back() {
      if(this.new_page_tab && !this.GL.ENV.is_afd_client){
          if(this.GL.ENV.is_ios){
            setTimeout(window.close, 301);//safari hack
            return false;
          }
          if(this.GL.ENV.is_android && window.history.length > 0){
            window.history.back();
            return false;
          }
      }
      if(this.GL.ENV.is_afd_client){
          this.$bridge.call("history_close", { }, e => {});
          return false;
      }
      if (this.$router.$from && this.$router.$from.name) {
        if(this.$router.$from.name == 'dashboardSponsored-bill'){
          this.$router.replace({ path: `/dashboard/sponsored-bill` });
          return false;
        }
        this.$router.go(-1);
      } else {
        this.$router.push("/");
      }
    },
    jump(name){
        let n = this.$route.name
        if(n != 'login' && n != 'reg'){ //防止这两个页面来回跳
            this.$store.commit('app/set:redirect_url', this.$route.fullPath);
        }
        this.$router.push({name});
    },
  }
};
</script>
<style lang="stylus" scoped>
.vm-nav-stack-mobile {
  height: $nav-mobile-height;
  padding: 0 px2rem(16);
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  box-sizing: border-box;
  // border-bottom 1px solid $black-1
  background: $white;
  z-index: 13;

  &.no-border {
    border: 0;
  }

  .left-area {
    margin-left: _px2rem(6);
  }

  .title-area {
    text-align: center;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    max-width: 60%;
    white-space: normal;
    word-break: keep-all;
    display: flex;
    align-items: center;
  }
}
</style>
